


// export const API_URL = 'http://localhost:8000/v1';
// export const API_URL = 'https://appstaging-api.diamondsdirect.com/v1';
export const API_URL = process.env.REACT_APP_API_URL;

// export const CUSTOMER_API_URL = 'http://localhost:8000/v1';
// export const CUSTOMER_API_URL = 'https://ddstuserapi1.diamondsdirect.com';
export const CUSTOMER_API_URL = process.env.REACT_APP_CUSTOMER_API_URL;
export const CUSTOMER_CREATE_URL = process.env.REACT_APP_CUSTOMER_CREATE_URL;

// export const PRODUCT_API_URL = 'http://localhost:8000/v1';
// export const PRODUCT_API_URL = 'https://ddstprodapi1.diamondsdirect.com';
export const PRODUCT_API_URL = process.env.REACT_APP_PRODUCT_API_URL;

// export const FRONTEND_URL = 'https://appstaging.diamondsdirect.com';
export const FRONTEND_URL = process.env.REACT_APP_FRONTEND_URL;

export const HEADERS = {
	'Accept': 'application/json',
	'Content-Type': 'application/json',
};
export const FILE_HEADERS = {
	'Accept': 'application/json'
};

// export const IS_STAGING = true;
export const IS_STAGING = process.env.REACT_APP_PLATFORM !== 'PROD';